module.exports = __webpack_public_path__ + "static/media/cancel.5a17d908.svg";